import React from 'react';
import { classes, st } from './YearDropdown.st.css';
import setYear from 'date-fns/setYear';

import { DropdownPicker as DatePickerDropdown } from '../../DatePickerDropdown';
import { YearDropdownProps } from './YearDropdown.types';

const YearDropdown = ({
  className,
  date,
  onChange,
  ariaLabel,
  ariaLabelledBy,
}: YearDropdownProps) => {
  const year = date.getFullYear();
  const maxYear = Math.max(year, new Date().getFullYear() + 15);
  const minYear = Math.min(year - 1, 1899);

  const years = Array.from({ length: maxYear - minYear }, (_, i) => ({
    id: i,
    value: maxYear - i,
  }));

  const selectedYear = years.find(({ value }) => value === year) ?? years[0];

  return (
    <DatePickerDropdown
      dataHook="datepicker-year-dropdown"
      className={st(classes.root, className)}
      caption={selectedYear.value}
      options={years}
      selectedId={selectedYear.id}
      onChange={({ value }) => onChange(setYear(date, value as number))}
      ariaLabel={ariaLabel}
      ariaLabelledBy={ariaLabelledBy}
    />
  );
};

export { YearDropdown };
